module.exports = __webpack_public_path__ + "img/0DBD0D_049704_047B04_045504-256px.8a19cf57.png";